import React from "react";

interface CourseBuilderLayoutProps {
  courseInfo: React.ReactNode;
  structure: React.ReactNode;
  lessonEditor: React.ReactNode;
}

export default function CourseBuilderLayout(props: CourseBuilderLayoutProps) {
  const { courseInfo, structure, lessonEditor } = props;

  return (
    <div className="space-y-6">
      {courseInfo}
      <div className="grid grid-cols-1 gap-6 xl:grid-cols-5">
        <div className="xl:col-span-3">{structure}</div>
        <div className="xl:col-span-2">{lessonEditor}</div>
      </div>
    </div>
  );
}
